import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <h4 className="font-heading text-lg font-semibold text-background-50 mb-4">
                Hitozuma 专题
              </h4>
              <p className="text-sm text-background-400 leading-relaxed">
                致力于为 hitozuma 文化研究者和爱好者提供全面、专业的内容导览与资源索引，推动该文化领域的健康发展与深度交流。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
                内容分类
              </h4>
              <ul className="flex flex-col gap-2">
                {categories.map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
                快速链接
              </h4>
              <ul className="flex flex-col gap-2">
                <li>
                  <Link
                    to="/"
                    className="text-sm text-background-400 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    首页
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-background-400 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    关于我们
                  </Link>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-sm text-background-400 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    使用条款
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-sm text-background-400 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    隐私政策
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
                联系我们
              </h4>
              <ul className="flex flex-col gap-2 text-sm text-background-400">
                <li className="flex items-center gap-2">
                  <i className="ri-mail-line w-4 h-4 flex items-center justify-center"></i>
                  <span>contact@hitozuma-guide.com</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-map-pin-line w-4 h-4 flex items-center justify-center"></i>
                  <span>日本东京都</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} Hitozuma 专题导览. 本站内容仅供文化研究与学术参考。
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-background-500 hover:text-accent-400 transition-colors cursor-pointer" aria-label="Twitter">
                <i className="ri-twitter-x-line w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a href="#" className="text-background-500 hover:text-accent-400 transition-colors cursor-pointer" aria-label="GitHub">
                <i className="ri-github-line w-4 h-4 flex items-center justify-center"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}